import foo from "../../data/data";
import ProjectComponent from "./ProjectComponent";

function Projects() {
  const allProjects = foo.map((item) => {
    return <ProjectComponent key={item.id} item={item} />;
  });
  return (
    <div className="ab-br">
      <p className="light pd-bt">//projects</p>
      {allProjects}
    </div>
  );
}

export default Projects;
